import React, { useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ThemeContext from '../contexts/ThemeContext';
import i18n from '../i18n';
import { ChevronRightIcon } from './PrebookingIcons';

const StepperContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 16px;
  margin-bottom: 32px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 8px;
  }
`;

const StepWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 16px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding: 0 8px;
  }
`;

const StepList = styled.ol`
  display: block;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0.5px;
  color: ${({ colors }) => colors?.heroDarkBrown};
  list-style-position: outside;
  padding: 0;
  margin: 0;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const StepItem = styled.li`
  margin-left: 21px;
  white-space: pre-wrap;
  font-weight: ${({ isActive }) => (isActive ? '700' : '500')};

  @media (max-width: 768px) {
    margin-left: 18px;
  }
`;

const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 16px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding: 0 4px;
  }
`;

const ChevronIconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  @media (max-width: 768px) {
    width: 20px;
    height: 20px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

const steps = [
  { number: 1, label: i18n('details') },
  { number: 2, label: i18n('preferences') },
  { number: 3, label: i18n('invoicing_and_assignment_details') },
  { number: 4, label: i18n('summary') },
];

const PrebookingStepIndicator = ({ currentStep }) => {
  const { colors } = useContext(ThemeContext);

  return (
    <StepperContainer>
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <StepWrapper>
            <StepList colors={colors} start={step.number}>
              <StepItem isActive={currentStep === step.number}>
                {step.label}
              </StepItem>
            </StepList>
          </StepWrapper>
          {index < steps.length - 1 && (
            <ArrowWrapper>
              <ChevronIconWrapper>
                <ChevronRightIcon color={colors?.twilight} size={24} />
              </ChevronIconWrapper>
            </ArrowWrapper>
          )}
        </React.Fragment>
      ))}
    </StepperContainer>
  );
};

PrebookingStepIndicator.propTypes = {
  currentStep: PropTypes.number.isRequired,
};

export default PrebookingStepIndicator;
